import styled from 'styled-components';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import Icon from '@front/web-ui/src/components/icon/icon';

const Advantage = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
`;

const AdvantageIcon = styled(Icon)`
  margin-right: 10px;
  flex-shrink: 0;
`;

type AdvantagesProps = {
  advantages: string[];
};

const Advantages = ({ advantages }: AdvantagesProps) => (
  <>
    {advantages.map((advantage) => (
      <Advantage key={advantage}>
        <AdvantageIcon name='yes' size={15} />
        <Text>{advantage}</Text>
      </Advantage>
    ))}
  </>
);

export default Advantages;
